import { Search as SearchComponent } from 'components/inputs/Search';
import { useTableContext } from '../providers/TableProvider';

const id = 'tableSearchInput';

type SearchProps = {
  searchOpen: boolean;
  setSearchOpen: (value: boolean) => void;
};

export const Search = ({ searchOpen, setSearchOpen }: SearchProps) => {
  const { globalFilter, setGlobalFilter, table, config } = useTableContext();

  const inputValue = table.options.meta?.onTableStateChange
    ? table.options.meta.tableState?.search ?? ''
    : globalFilter ?? '';

  const handleOnChange = (value: string) => {
    if (table.options.meta?.onTableStateChange) {
      table.options.meta.onTableStateChange({
        search: value || undefined,
        page: null,
        cursor: null,
      });
    } else {
      setGlobalFilter(value);
    }
    config?.event?.('searched', null);
  };

  const onClear = () => {
    setSearchOpen(false);
    handleOnChange('');
  };

  return (
    <SearchComponent
      id={id}
      data-testid={`table_${config.tableId}_search_button`}
      value={inputValue}
      onChange={handleOnChange}
      placeholder="Search"
      onClear={onClear}
      searchOpen={searchOpen}
      onSearchOpenChange={setSearchOpen}
    />
  );
};
